import * as React from "react";
import { Button, FormGroup, FormControl, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { History } from "history";
import { FormattedMessage } from "react-intl";

import * as Auth from "../lib/Auth";
import ErrorComponent from "./ErrorComponent";

type Props = {
    history: History;
};

type State = {
    email: string;
    submitted: boolean;
    message: string;
};

class RecoverPassword extends React.Component<Props, State> {
    state: State = {
        email: "",
        submitted: false,
        message: "",
    };

    validateForm() {
        return Auth.validateEmail(this.state.email);
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let target = event.target;
        if (target instanceof HTMLInputElement) {
            if (target.id === "email") {
                const email = target.value;
                this.setState({ email });
            }
        }
    };

    handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await Auth.recoverPassword(this.state.email);
            this.setState({ message: "", submitted: true });
        } catch (err: unknown) {
            this.setState({ message: (err as Error).message });
        }
    };

    render_alert() {
        return <ErrorComponent msg={this.state.message} type="warning" />;
    }

    render() {
        if (this.state.submitted) {
            // we already submitted for notification
            return (
                <section id="register" key="1">
                    <div className="caption_div">
                        <form className="form_box">
                            <h3>
                                <FormattedMessage id="Settings.recover_password" defaultMessage="Recover password" />
                            </h3>
                            {this.state.message !== "" && this.render_alert()}
                            <div className="form-group row m-t-30">
                                <br />
                                <Form.Label>
                                    An email has been send to <b>{this.state.email}</b>. Please check for an email from
                                    our company and click on the included link to reset your password
                                </Form.Label>
                            </div>
                            <div className="form-group row m-t-30">
                                <div className="col-sm-7">
                                    <Link className="blue_link" to="/login">
                                        <FormattedMessage id="common.sign_in" defaultMessage="Login" />
                                    </Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
            );
        }

        // we are waiting for the user to enter email
        return (
            <section id="register" key="1">
                <div className="caption_div">
                    <form className="form_box" onSubmit={this.handleSubmit}>
                        <h3>
                            <FormattedMessage id="Settings.recover_password" defaultMessage="Recover password" />
                        </h3>
                        {this.state.message !== "" && this.render_alert()}
                        <FormGroup controlId="email" className="form-group">
                            <Form.Label>
                                <FormattedMessage id="Settings.enter_email" defaultMessage="Enter email" />
                            </Form.Label>
                            <FormControl
                                autoFocus
                                type="text"
                                placeholder="Your email address"
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <Button
                            block
                            className="btn_register btn-primary"
                            disabled={!this.validateForm()}
                            type="submit"
                        >
                            <FormattedMessage id="common.reset" defaultMessage="Reset" />
                        </Button>
                        <div className="row">
                            <div className="col-sm-7">
                                <Link className="blue_link" to="/login">
                                    <FormattedMessage id="common.sign_in" defaultMessage="Login" />
                                </Link>
                            </div>
                            <div className="col-sm-5 text-right">
                                <Link className="blue_link" to="/register">
                                    <FormattedMessage id="common.create_account" defaultMessage="Create an account" />
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}

export default RecoverPassword;
